<template>
  <div class="home-module-functions">
    <div class="home-module-functions-header-view">
      {{ title }}
    </div>
    <div class="home-module-functions-list">
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="routeTo(item)"
        class="home-module-functions-list-item"
      >
        <span>{{ item.menuname }}</span>
        <img v-if="item.icon" v-lazy="item.icon" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    routeTo(item) {
      this.$emit("routeTo", item);
    }
  }
};
</script>

<style lang="less">
.home-module-functions {
  margin-top: 0.5rem;

  &-header-view {
    margin-left: 12px;
    font-weight: 500;
    font-size: 1rem;
    line-height: 2.2rem;
  }

  &-list {
    display: flex;
    flex-wrap: wrap;

    &-item {
      display: flex;
      align-items: center;
      width: calc(50% - 0.8rem);
      height: 2.2rem;
      margin: 0.2rem 0.4rem;
      color: #555;
      background-color: white;
      border-radius: 5px;
      box-shadow: 0 1px 4px 2px rgba(0, 0, 0, 0.03);

      span {
        margin-left: 0.47rem;
        font-size: 0.81rem;
      }
      img {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: 0.47rem;
        margin-left: auto;
      }
    }
  }
}
</style>
